import React from 'react'
import { selectIsAvailableBySku } from 'Catalog/Availability/ducks'
import { connect } from 'react-redux'

export const IfAvailable = ({ isAvailable, children, component: Component, ...props }) =>
  isAvailable ? children || <Component {...props} /> : null

const mapStateToProps = (state, props) => ({
  isAvailable: selectIsAvailableBySku(state, props)
})

export default connect(mapStateToProps)(IfAvailable)



// WEBPACK FOOTER //
// ./src/Catalog/Availability/IfAvailable.js